/**
 * Phase 1 in-app “notification” ສຳລັບວຽກມອບໝາຍ — ຄຳນວນສົດ (ບໍ່ມີຕາຕະລາງແຈ້ງເຕືອນ).
 * ແນວຄິດຄ້າຍ checklist: `computeChecklistAlertStatus` + CHECKLIST_DUE_SOON_HOURS.
 */

/** ຈຳນວນວັນກ່ອນວັນຄົບທີ່ຖືວ່າ “ໃກ້ຄົບກຳນົດ” (ວັນທີງານແບບມີວັນຄົບເຕັມວັນ). */
export const ASSIGNED_TASK_DUE_SOON_DAYS = 7;

export type AssignedTaskAlertStatus = "none" | "due_soon" | "overdue";

/**
 * - overdue: ມີວັນຄົບແລະເລີຍສິ້ນວັນແລ້ວ (ຍັງບໍ່ done)
 * - due_soon: ຍັງບໍ່ເລີຍ ແຕ່ເຫຼືອ ≤ ASSIGNED_TASK_DUE_SOON_DAYS ວັນ
 */
export function computeAssignedTaskAlertStatus(
  status: string,
  dueDate: string | null,
  nowMs: number = Date.now(),
): AssignedTaskAlertStatus {
  if (status === "done" || !dueDate) return "none";
  const end = new Date(`${dueDate}T23:59:59`);
  if (Number.isNaN(end.getTime())) return "none";
  if (end.getTime() < nowMs) return "overdue";
  const days = (end.getTime() - nowMs) / (24 * 60 * 60 * 1000);
  if (days <= ASSIGNED_TASK_DUE_SOON_DAYS) return "due_soon";
  return "none";
}
